/** True when focus is in a field where keyboard shortcuts must not steal Space/Enter. */
export function isTypingInEditableField(): boolean {
  const active = document.activeElement;
  if (!active) return false;
  return (
    active.tagName === 'INPUT' ||
    active.tagName === 'TEXTAREA' ||
    active.tagName === 'SELECT' ||
    (active instanceof HTMLElement && active.isContentEditable)
  );
}
